export default "__VITE_ASSET__C0ECP3Vi__"